// GENERATE BY ./scripts/generate.ts
// DON NOT EDIT IT MANUALLY
import * as React from 'react';
import DrrpDataIconOutlinedSvg from "@fishx/icons-svg/es/asn/DrrpDataIconOutlined";
import FishxIcon from '../components/FishxIcon';

var DrrpDataIconOutlined = function DrrpDataIconOutlined(props, ref) {
  return React.createElement(FishxIcon, Object.assign({}, props, {
    ref: ref,
    icon: DrrpDataIconOutlinedSvg
  }));
};

DrrpDataIconOutlined.displayName = 'DrrpDataIconOutlined';
export default React.forwardRef(DrrpDataIconOutlined);


//////////////////
// WEBPACK FOOTER
// ./node_modules/@fishx/icons/es/icons/DrrpDataIconOutlined.js
// module id = 2540
// module chunks = 0